import { WarningStep } from "#/components/carrot-card-cost-share/steps/variants/WarningStep"
import { Link } from "@carrotfertility/carotene-core"
import React from "react"
import { useIntl } from "react-intl"
import { Link as RouterLink } from "react-router-dom"
import { DbgPaths } from "#/utils/Paths"

export function ExpenseNotCoveredStep(): JSX.Element {
  const intl = useIntl()
  return (
    <WarningStep
      title={intl.formatMessage({ defaultMessage: "This expense is not covered." })}
      primaryDescription={intl.formatMessage(
        {
          defaultMessage: "Review your <link>benefit guide</link> for more information on eligible care and services."
        },
        {
          link: (linkContent) => (
            <Link
              component={RouterLink}
              to={DbgPaths.CARROT_ELIGIBLE}
              color="inherit"
              target="_blank"
              rel="noopener noreferrer"
            >
              {linkContent}
            </Link>
          )
        }
      )}
      secondaryDescription={intl.formatMessage(
        {
          defaultMessage: "Please <link>contact us</link> if you think you're seeing this message in error."
        },
        {
          link: (linkContent) => (
            <Link component={RouterLink} to="/care-team" color="inherit" target="_blank" rel="noopener noreferrer">
              {linkContent}
            </Link>
          )
        }
      )}
    />
  )
}
